import Vue from "vue";

Vue.component("crn-notification-number-dropdown", {
	props: ["notificationFormatId", "notificationId", "linkedNotificationIds", "placeholder", "errors", "isReadOnly"],
	data() {
		return {
			crnNumbers: []
		};
	},
	computed: {
		computedValue: {
			get() {
				const ids = this.linkedNotificationIds;
				if (!ids || ids.length === 0) return [];
				return ids;
			},
			set(value) {
				this.$emit("update:linkedNotificationIds", value);				
			}
		}
	},
	methods: {
		getCRNNumberForDropdown: function () {
			this.$services.notifications.getCRNNumberForDropdown({
				notificationFormatId: this.notificationFormatId,
				notificationId: this.notificationId
			})
				.then((data) => {
					this.crnNumbers = data.items;
				});
		},
	},
	mounted: function () {
		this.getCRNNumberForDropdown();
	},
	template: `
      <div class="column is-full-mobile">
		  <wto-multi-select
			  ref="crnNumbersRef"
			  :label-position="'on-border'"
			  :placeholder="placeholder"
			  :is-read-only="isReadOnly"
			  :on-border="true"
			  :items="crnNumbers"
			  :ids.sync="computedValue"
			  :error.sync="errors">
		  </wto-multi-select>
      </div>		
	`
});